


















































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import HeaderBar from '@/components/header-bar/index.vue'
import MSlider from '@/components/m-slider/index.vue'
import Popup from '@/components/popup/index.vue'
import TabItems from './tab-items.vue'
import DataPreview from './data-preview.vue'
import { jumpPage } from '@/utils/mUtil'
import { CHECK_STATUS } from '@/constants/applyForm'
import { getCertifiStauts } from '@/services/apply'

const dataIntro = [
  '视频播放量：所有视频产生的历史总播放量',
  '专栏阅读量：所有专栏产生的历史总阅读量',
  '总获赞量：视频和专栏合并的总获赞量',
  '总评论量：视频和专栏合并的总评论量',
  '详细数据请至pcweb创作中心查看',
]

@Component({ components: { HeaderBar, MSlider, TabItems, DataPreview, Popup } })
export default class Home extends Vue {
  // sliderList: any = mockList
  CHECK_STATUS = CHECK_STATUS
  auditVisible = false
  improvedVisible = false
  dataIntro = dataIntro
  dataPopupVisible = false
  unimproveVisible = false
  unCertifiVisible = false
  ispartnerVisible = false
  popTitle: string = ''
  inBuffer: Boolean = false
  noVerifi: Boolean = false
  isPerson = true

  timer: any

  // @Watch('checkStatus')
  // watchValue() {
  //   this.getCertiStatus()
  // }

  @Watch('userInfo')
  watchValue() {
    this.statusIspartner()
  }

  get userInfo() {
    return this.$store.state.userInfo
  }

  get userInfoInapp() {
    return this.$store.state.userInfoInapp
  }

  get hotList() {
    return this.$store.state.homeData.imgTextAct || []
  }

  // eslint-disable-next-line complexity
  get checkStatus() {
    if (this.userInfo && !isNaN(this.userInfo.accountState)) {
      // 判断入驻状态
      if (this.userInfo.accountState != 0) {
        if (
          this.userInfo.accountType === 1 &&
          this.userInfo.accountState === 2
        ) {
          this.noVerifi = false // 通过实名认证: 是
          this.isPerson = true // 是否个人入驻: 是
        } else {
          this.noVerifi = true // 通过实名认证: 否
          this.isPerson = false // 是否个人入驻: 否
        }
        return this.userInfo.accountState
      }
      // 判断是否入驻分账剧品类
      if (this.userInfo.partnerState === 2) {
        return this.CHECK_STATUS.ISPARTNER
      }
      // 分账剧审核中
      if (this.userInfo.partnerState === 1) {
        return this.CHECK_STATUS.AUDITINT
      }
      // 分账剧审核不通过
      if (
        this.userInfo.partnerState === 3 ||
        this.userInfo.partnerState === 4
      ) {
        return this.CHECK_STATUS.INFO_GET
      }
    }
    return this.CHECK_STATUS.NOT_APPLY
  }

  popBtnLeftTxt(): string {
    if (this.userInfo && !isNaN(this.userInfo.accountState)) {
      //let settledStatus = this.userInfo.extInfo.settledStatus
      if (this.checkStatus == CHECK_STATUS.GETTED && this.noVerifi) {
        return '以后再说'
      } else {
        return '知道了'
      }
    } else {
      return '知道了'
    }
  }

  popBtnRightTxt(): string {
    if (this.userInfo && !isNaN(this.userInfo.accountState)) {
      //let settledStatus = this.userInfo.extInfo.settledStatus
      if (this.checkStatus == CHECK_STATUS.GETTED && this.noVerifi) {
        return '立即认证'
      } else {
        return '再次申请'
      }
    } else {
      return '再次申请'
    }
  }

  get sliderList() {
    // 限制闪图的个数
    return (
      (this.$store.state.homeData.banner &&
        this.$store.state.homeData.banner.list) ||
      []
    ).slice(0, 10)
  }

  beforeMount() {
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
  }

  mounted() {
    // this.getCertiStatus()
    this.statusIspartner()
  }
  statusIspartner() {
    // 实名认证弹窗
    if (this.userInfo && !isNaN(this.userInfo.accountState)) {
      // 判断是否入驻分账剧品类
      if (this.userInfo && this.userInfo.partnerState === 2) {
        this.ispartnerVisible = true
        return
      } else {
        this.ispartnerVisible = false
      }
      // 判断入驻状态
      // if (this.userInfo && this.userInfo.accountState == 0) {
      //   this.unCertifiVisible = true
      // }
    }
  }

  handlerPop() {
    // 机构过了缓冲期，不弹窗
    if (
      !this.inBuffer &&
      (this.userInfo.settledType === 1 || this.userInfo.settledType === 2)
    ) {
      //do nothing
    } else {
      this.unCertifiVisible = true
    }
  }

  async getCertiStatus() {
    const res = await getCertifiStauts({
      uuid: this.userInfoInapp.uuid,
      ticket: this.userInfoInapp.ticket,
    })
    if (res && res.code === 200) {
      if (res.data.verificationStatus === 0) {
        // 0:未通过实名认证，1:通过实名认证
        this.noVerifi = true
        // 0在缓冲日期内，1过了缓冲日期
        this.inBuffer = res.data.deadline === 0

        if (this.checkStatus === CHECK_STATUS.GETTED && this.noVerifi) {
          setTimeout(() => {
            // @ts-ignore
            this.$refs.cerBtn.click()
          }, 300)
        }
      } else {
        this.noVerifi = false
      }
    }
  }

  created() {
    this.$store.dispatch('getBannerAction')
  }

  showInfo(type: string) {
    ;(this as any)[type] = true

    if (this.timer) {
      clearTimeout(this.timer)
    }

    this.timer = setTimeout(() => {
      ;(this as any)[type] = false
      clearTimeout(this.timer)
    }, 3000)
  }

  jumpPage(item: any) {
    if (!item || !item.landing) return
    jumpPage(item.landing)
  }

  exitWebview() {
    ;(window as any).MgtvApi.closeWebView()
  }
}
